module.exports = __webpack_public_path__ + "img/blpsl.33279098.png";